<template>
    <div class="section-confirm">
        <div class="container text-center">
            <div class="logo-container">
                <img class="n-logo" width="130" height="40" src="img/logotipo_mod2.png" alt="U4CROWD" />
            </div>
            <div class="row justify-content-md-center">
                <div class="col-md-12 col-lg-8">
                    <h3 class="title">Confirmation Email!</h3>
                    <span v-if="loading"><square-grid background="#FFFFFF"></square-grid> Loading...</span>
                    <alert v-if="success" type="success">
                        {{success.message}}
                    </alert>
                    <alert v-if="error" type="danger">
                        {{error.message}}
                    </alert>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {RotateSquare2, SquareGrid} from 'vue-loading-spinner'
import { Alert } from '@/components';
import Auth from '@/providers/Auth'
const AuthProvider = new Auth()

export default {
  name: 'confirm-email',
  components: {
    RotateSquare2,
    SquareGrid,
    Alert
  },
  mounted() {
      this.validToken(this.$route.query._tk);
  },
  data() {
    return {
        loading: false,
        error: null,
        success: null
    }
  },
  methods: {
      validToken(token) {
        this.loading = true
        let data = {
            _tk: token
        }
        AuthProvider.confirm(data).then((resp)=> {
            this.error = null
            setTimeout(() => {
                this.loading = false
                this.success = {
                    message: "Thanks for confirmed email!"
                }
                setTimeout(() => {
                    this.$router.push('/') 
                }, 3000);
            }, 3000);
            
        }).catch((err)=>{
            this.loading = false
            if(err.status && (err.status === 403)) {
                this.error = {
                    message: "Time expired!"
                }
            }else {
                this.error = {
                    message: "Error comunication"
                }
            }
      })
      }
  }
};
</script>
<style>
</style>
